import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { Screen } from "@/components/screen";
import { Button, Card, Field } from "@/components/ui";

export default function Join() {
  const navigate = useNavigate();
  const [code, setCode] = useState("");

  function handleJoin() {
    if (code.trim()) {
      navigate({ to: `/join/${code.trim()}` });
    }
  }

  return (
    <Screen
      eyebrow="Join"
      title="Join a competition"
      subtitle="Enter the invite code shared by a friend to join an existing competition."
    >
      <Card>
        <Field label="Invite code" value={code} onChangeText={setCode} placeholder="e.g. ABC123" />
        <Button label="Join competition" onPress={handleJoin} />
      </Card>
    </Screen>
  );
}
